import { useMutation } from '@tanstack/react-query';

import { deleteApprovalDocumentApi } from '../api';

export default function useDeleteApprovalDocumentMutation(options?: any) {
  return useMutation(deleteApprovalDocumentApi, options);
}
